import { StyledArrowButton } from './CircularArrowButton.styled';

interface ICircularArrowButtonProps
	extends React.HTMLAttributes<HTMLDivElement> {
	direction: 'left' | 'right' | 'up' | 'down';
}

const CircularArrowButton = ({
	direction,
	...props
}: ICircularArrowButtonProps) => (
	<StyledArrowButton $direction={direction} {...props} />
);

export { CircularArrowButton };
